import { useSearchParams } from 'react-router-dom';
import { format } from 'date-fns';
import { PageLayout } from '@/components/layout/PageLayout';
import { CheckCircle2 } from 'lucide-react';

export function ScheduleConfirmation() {
  const [searchParams] = useSearchParams();
  const dateParam = searchParams.get('date');
  const timezoneParam = searchParams.get('tz');

  const scheduledDate = dateParam ? new Date(dateParam) : null;

  return (
    <PageLayout>
      <div className="text-center py-12 space-y-4">
        <CheckCircle2 className="h-16 w-16 text-green-500 mx-auto" />
        <h2 className="text-2xl font-bold tracking-tight">Test Scheduled Successfully</h2>
        <p className="text-muted-foreground max-w-md mx-auto">
          Your technical assessment has been scheduled. You will receive a confirmation email with further instructions.
        </p>

        {scheduledDate && (
          <div className="mt-6 rounded-lg border bg-card p-6 max-w-sm mx-auto space-y-2">
            <p className="text-sm text-muted-foreground">Scheduled Date and Time</p>
            <p className="text-lg font-semibold">
              {format(scheduledDate, 'EEEE, MMMM d, yyyy')}
            </p>
            <p className="text-lg font-semibold">
              {format(scheduledDate, 'h:mm a')}
            </p>
            {timezoneParam && (
              <p className="text-sm text-muted-foreground">
                {timezoneParam.replace(/_/g, ' ')}
              </p>
            )}
          </div>
        )}
      </div>
    </PageLayout>
  );
}
